export default {
    appHeader: {
        title: 'Solvis ER — Futures nadzorna plošča',
        signOut: 'Odjava',
        loading: 'Nalaganje…',
    },
}
